import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Spinner from '../common/Spinner';

const RequireRole = ({ roles, children, redirectTo = '/login' }) => {
  const { role, loading } = useAuth();

  if (loading) return <Spinner />;
  if (!role || !roles.includes(role)) return <Navigate to={redirectTo} replace />;

  return children;
};

export default RequireRole;
